module.exports = __webpack_public_path__ + "img/etax-lineHeader.a9c7c8e.png";